import { connect } from 'react-redux';

import { getChannelForWidget } from 'shared/selectors/channels';
import { getAllSettings } from 'shared/selectors/app-settings';

import getPaymentInfo from 'shared/redux/server/actions/channel/payment';

import DataLoader from 'shared/data-components/_data-loader';


@connect(state => ({
  channelData: getChannelForWidget(state),
  appSettings: getAllSettings(state),
}), {
  getPaymentInfo,
})
export default class PaymentInfoLoader extends DataLoader {

  static displayName = 'PaymentInfoLoader';

  static propTypes = {
    getPaymentInfo: React.PropTypes.func,
    appSettings: React.PropTypes.object,
    channelId: React.PropTypes.string,
  };

  dependencies = [
    'channelId',
  ];

  loadData() {
    const { channelId, getPaymentInfo, appSettings: { instance } } = this.props;

    if (!channelId) {
      return Promise.reject();
    }

    return getPaymentInfo(channelId, {
      instance,
    });
  }

  get childProps() {
    const { channelData } = this.props;
    const { isFetching } = this.state;
    return { channelData, channelPaymentData: { isFetching, fetch: this.loadDataDebounced } };
  }

}



// WEBPACK FOOTER //
// ./src/widget/data-components/payment-info.js